import React from 'react';
import {Tabs, Empty, Row, Col, Modal,message,Input} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../../constants";
import BaseComponent from "../../../base/BaseComponent";
import {connect} from "react-redux";
import {setInfoToLocalStorage} from "../../../actions";
import SyncModal from "../../components/syncModal/syncModal";
import {uuid} from "../../../utils";
import CmForm from "../../../components/CmForm/CmForm";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const {TabPane} = Tabs;

class
ReleaseMedia extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabKey: '网站',
            dataSource: [],
            total: 0,
            navigationBarDate: [],
            passWordValue:''
        }
    }


    componentDidMount() {
            this.getMediaPort()

    }

    componentWillUnmount = () => {
        this.setState = (state,callback)=>{
            return;
        };
    }

    //tab栏切换
    tabChange = (Key) => {
        this.state.tabKey = Key;
        this.setState({})
    };
    //navigationBarDate第一层logoUrl赋值给mediaList中得mediaLogo
    picSrc = (navigationBarDate) => {
        navigationBarDate.forEach((i, index2) => {
            i.mediaList.forEach(item => {
                if (!item.mediaLogo) {
                    item.mediaLogo = i.logoUrl;
                }
            })
        });
    };
    //媒体绑定功能
    mediaBinding = (media, callback) => {
        this.request({
            url: '/cm-sites-pms/website/getVsbUser',

            body: {
                // mediaId:'xxx',
                mediaId: media.menuCode,
                userId: window.currentUser.id
            },
            callBack: (res) => {
                callback(res)
            },
            serverVerify:{
                serverErrorCallBack:()=>{
                    message.destroy()
                    message.error('请联系管理员添加融媒发布媒体权限！')
                },
                isShowErrorMsg:false
            },
            errorCallBack: (e) => {
                console.log(e, 222)
            },
        })
    };
    //媒体id接口对接
    getMediaPort = () => {
        this.request({
            url: '/cm-sites-pms/media/getCurrentUserMediaGroupByType',
            callBack: (res) => {
               if(res&&res.length < 1){
                    message.destroy()
                    message.warning("暂无媒体，请联系管理员添加媒体或给您赋予媒体权限")
              }
                let navigationBarDate = [];
                if (res) {
                    navigationBarDate = res;
                    setInfoToLocalStorage("currentMediaList", res);
                    let allMediaList = [];
                    navigationBarDate.forEach(item => {
                        item["mediaList"] && item["mediaList"].length && item["mediaList"].sort((a, b) => {
                            return a.sort - b.sort
                        })
                        allMediaList.push(...item["mediaList"])
                    });
                    navigationBarDate.unshift({
                        mediaTypeName: "全部",
                        mediaList: allMediaList
                    });
                    this.picSrc(navigationBarDate)
                }
                this.setState({
                    navigationBarDate,
                })
            },
            errorCallBack: (e) => {
            },
        })
    };

    render() {
        let allMenu = this.props.dataSource || [];
        let currentMenu = [];
        allMenu.forEach((item, index) => {
            if (item.menuCode === "mediaPublish") {
                currentMenu = item.child
            }
        });
        //处理菜单数据合并到当前获取得媒体里面
        this.state.navigationBarDate.forEach((Item, Index) => {
            Item.mediaList.forEach((item2, index2) => {
                currentMenu.forEach((currentItem, currentIndex) => {
                    if (item2.id == currentItem.menuCode) {
                        this.state.navigationBarDate[Index].mediaList[index2] = {...item2, ...currentItem}
                    }
                })
            })
        });
        //合并后的菜单
        //高度
        let height = document.body.clientHeight- HEADER_HEIGHT -32;
        return (
            <div style={{
                backgroundColor: '#ffffff',
                maxHeight: height,
                fontFamily: "Microsoft YaHei",
                margin: '16px auto',
                borderRadius: "5px",
                paddingBottom: "17px",
            }}>
                {this.renderMediaTab()}
            </div>
        );
    }

    //媒体tab栏
    renderMediaTab = () => {
        let {navigationBarDate, allMedia} = this.state;
        // let allMediaList;
        // navigationBarDate.map((item, index) => {
        //     allMediaList=item['mediaList']
        // })
        return (
            <div style={{paddingTop: 24,}} className={'navigationBarStyle'}>
                {
                    (navigationBarDate && navigationBarDate.length)
                        ?
                        (<Tabs defaultActiveKey={navigationBarDate[0].mediaTypeName || '0'}
                               onChange={(Key) => {
                                   this.tabChange(Key)
                               }}>
                            {/*<TabPane tab={"全部"} key={"全部"}>{this.renderMediaList(navigationBarDate[0]['mediaList'])}</TabPane>*/}
                            {
                                navigationBarDate.map((item, index) => {
                                    return (
                                        <TabPane tab={item['mediaTypeName']} key={item['mediaTypeName']}
                                                 style={{fontWeight: 400, fontSize: "16px",}}>
                                            {this.renderMediaList(item['mediaList'])}
                                        </TabPane>
                                    )
                                })
                            }

                        </Tabs>)
                        : <div style={{margin: "auto", marginTop: "300px"}}><Empty/></div>

                }
                <style>
                    {`
                    .navigationBarStyle .ant-tabs-nav{
                     padding-left: 33px
                     }
                    `}
                </style>
            </div>

        )
    }

    //tab栏对应得媒体内容
    renderMediaList = (mediaList) => {
        let ScrollbarsHeight = window.innerHeight - HEADER_HEIGHT - 16 - 45 - 41 - 15;
        this.picSrc(this.state.navigationBarDate);
        return (
            <Scrollbars  autoHeight autoHeightMax={ScrollbarsHeight}>
                <div style={{
                    padding: " 0px 20px"
                }}>
                    <Row type={"flex"}>
                        {(mediaList && mediaList.length) ?
                            mediaList.map((media, index) => {
                                let mediaLogo = media.mediaLogo;
                                return (
                                    <Col xxl={6} xl={8} lg={12} md={12} sm={12} xs={24} key={index}
                                         style={{
                                             marginTop: 24,
                                             padding: '0px 12px',
                                         }}
                                         onClick={() => {
                                             this.jumRoute(media)
                                         }
                                         }
                                    >
                                        <div style={{
                                            position: 'relative',
                                            background: 'rgba(0, 80, 179, 0.04)',
                                            height: '134px',
                                            border: "1px solid #d1d3d7",
                                            cursor: 'pointer',
                                        }}>
                                            {media && media.disable === 0 ? null : <div style={{
                                                position: "absolute",
                                                top: 0, right: 0,
                                                width: 52,
                                                height: 24, borderRadius: "0 2px", background: "#f56c6c",
                                                fontSize: 12, color: " #fff",
                                                display: 'flex', justifyContent: "center",
                                                alignItems: "center",
                                            }}>
                                                已禁用
                                            </div>}
                                            {((media && media.authResult === 1) || media.mediaTypeCode === "rmapp") ? null : <div style={{
                                                position: "absolute",
                                                top: 0, right: 0,
                                                width: 52,
                                                height: 24, borderRadius: "0 2px", background: "#f56c6c",
                                                fontSize: 12, color: " #fff",
                                                display: 'flex', justifyContent: "center",
                                                alignItems: "center",
                                            }}>
                                                未认证
                                            </div>}

                                            <div style={{display: 'flex', padding: '24px 16px'}}>
                                                <div style={{
                                                    width: 47
                                                }}>
                                                    <img src={mediaLogo}
                                                         style={{
                                                             width: 47,
                                                             height: 47,
                                                             borderRadius: '50%',
                                                             objectFit: 'cover'
                                                         }}
                                                    />
                                                </div>
                                                <div style={{
                                                    flex: 1,
                                                    marginLeft: 16,
                                                    width: 281
                                                }}>
                                                    <h3 style={{
                                                        fontSize: "16px",
                                                        marginBottom: 4,
                                                        lineHeight: "21px",
                                                        width: 'cale(100% - 50px)',
                                                    }}
                                                        className={"titleHidden"}
                                                        title={media.name}
                                                    >{media.name}</h3>
                                                    <p style={{

                                                        height: 132 - 48 - 21 - 4,
                                                        fontSize: "14px",
                                                        margin: 0,
                                                        lineHeight: "20px",
                                                        textAlign: 'left',
                                                        WebkitBoxOrient: "vertical",
                                                        letterSpacing: 1

                                                    }} className={"textHidden"} title={media.description}>
                                                        {media.description ? media.description : "暂无简介"}
                                                    </p>
                                                    <style>
                                                        {`
                                                        .titleHidden{
                                                        overflow: hidden;
                                                        text-overflow:ellipsis;
                                                        white-space: nowrap;
                                                        }
                                                        .textHidden{
                                                        
                                                        
                                                       
                                                        display: -webkit-box;
                                                        word-break: break-all;
                                                        text-overflow: ellipsis; 
                                                        overflow: hidden;
                                                        -webkit-line-clamp: 3;
                                                        

                                                        }
                                                        `}
                                                    </style>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>


                                )
                            }) : <div style={{margin: "auto", marginTop: "300px"}}><Empty/></div>}
                    </Row>
                </div>
                <SyncModal ref={ref => this.syncModal = ref}/>
            </Scrollbars>
        )
    };

    //验证账号信息
    verifyAccount = (params, media) => {
        console.log('params',params)

        this.request({
            url: '/cm-sites-pms/website/getUser',
            method: 'post',
            body: {
                ...params
            },
            callBack: (res) => {
                params.vsbUserName = res.wbname;
                this.request({
                    url: '/cm-sites-pms/website/getUserList?mediaId=' + media.menuCode + "&page=1&size=1000",
                    method: 'get',
                    callBack: (res)=>{
                        if(res && res.data){
                            let contains = false;
                            res.data.forEach(item =>{
                                if(item.wbaccount === params.account){
                                    contains = true;
                                }
                            });
                            if(contains){
                                this.bindVsbUser(params, media);
                            }else {
                                message.destroy();
                                message.warn("当前账号无该站点管理权限！");
                            }
                        }
                    },
                    errorCallBack: (e) => {
                        const modalError = Modal.error({
                            title: '绑定失败',
                            content: '无管理权限！',
                            okText: '确定'
                        });
                    }
                });
            },
            errorCallBack: (e) => {
                const modalError = Modal.error({
                    title: '绑定失败',
                    content: '账号或密码错误，请检查后重新输入！',
                    okText: '确定'
                });
            },
            serverVerify:{
                isShowErrorMsg:false,
                serverErrorCallBack:()=>{
                    const modalError = Modal.error({
                        title: '绑定失败',
                        content: '账号或密码错误，请检查后重新输入！',
                        okText: '确定'
                    });
                }
            }
        })
    }
    //保存账户信息
    bindVsbUser = (params, media) => {

        this.request({
            url: '/cm-sites-pms/website/bindVsbUser',
            method: 'post',
            contentType: 'json',
            body: {
                "owner": media.owner.owner,
                "userId": window.currentUser.id,
                "userName": window.currentUser.name,
                "vsbUserAccount": params.account,
                "vsbUserName": params.vsbUserName,
            },
            callBack: (res) => {
                console.log(res, "请求成功")
                //成功
                const modalSuccess = Modal.success({
                    title: '绑定成功',
                    content: '您可以使用网站内容管理功能了！',
                    okText: '确定'
                });
                this.openNetworkMediaJump(media)
            },
            errorCallBack: (e) => {

            },
        })
    }

    menuClick(menuItem){
        //处理菜单数据合并到当前获取得媒体里面
        let currentMedia={};
        this.state.navigationBarDate.forEach((Item, Index) => {
            Item.mediaList.forEach((item2, index2) => {
                if (item2.menuCode == menuItem.menuCode) {
                    currentMedia = {...item2, ...menuItem}
                }
            })
        });
        if(currentMedia.id){
            this.jumRoute(currentMedia)
        }

    }

    //媒体绑定事件
    jumRoute(media) {
       
        //获取当前用户所有可以访问的角色权限
        let windowRoleList = []

        window.currentUser && window.currentUser.roleList && window.currentUser.roleList.length && window.currentUser.roleList.forEach((item) => {
            item.menuCods && item.menuCods.length && item.menuCods.forEach((Item) => {
                windowRoleList.push(Item)
            })
        });
        if(windowRoleList.indexOf(media.mediaTypeCode) == -1){
            message.destroy();
            message.warning("请设置媒体系统权限!");
            return;
        }
        //判断当前点击的类型为新闻，未认证时的拦截动作
        if(media.mediaTypeCode == 'webNews' && media.authResult == 0){
            message.destroy()
            message.error('媒体未认证，请在媒体管理中对媒体进行认证！')
            return;
        }
        // //判断当前点击的类型为微信公众号，未认证时的拦截动作
        // if(media.mediaTypeCode == 'material' && media.authResult == 0){
        //     message.destroy()
        //     message.error('媒体未认证，请在媒体管理中对媒体进行认证！')
        //     return;
        // }
        //新增网站，路径path未更新的拦截操作
        if(!media.path){
            message.destroy();
            message.warning("请刷新浏览器!");
            return;
        }
        //点击网站并且已验证
        if (media.mediaTypeCode == 'webNews' && media.authResult == 1) {
            let that = this;
            this.mediaBinding(media, (res) => {
                if (!res) {
                    that.syncModal.confirm({
                        title: "提示",
                        width: 400,
                        content:
                            <CmForm key={uuid()} onSubmit={() => {
                                that.onHandleOk(that, media)
                            }}>
                                <div>
                                    <p>首次使用网站，请绑定你的网站群的用户账号和密码</p>
                                    账号：<Input placeholder={"请输入网站管理员账号"} maxLength={200} rows={2}
                                              style={{width: 300, height: 30, fontSize: 14, marginBottom: 10}}
                                              ref={(input) => that.input1 = input}/><br/>
                                    密码：<Input.Password placeholder={"请输入密码"} maxLength={200} rows={2}
                                              style={{width: 300, height: 30, fontSize: 14}}
                                              type={"password"} autoComplete="new-password"
                                              onChange={(e)=>{this.setState({passWordValue:e.target.value})}}
                                              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                              ref={(input) => that.input2 = input}/>
                                </div>
                            </CmForm>,
                        okText: "确定",
                        cancelText: "取消",
                        onOk: () => {
                            that.onHandleOk(that, media)
                        },
                        onCancel: () => {
                            that.syncModal.destroy()
                        }
                    });
                } else {
                    this.openNetworkMediaJump(media)
                }
            })
        }
        else{
            this.openNetworkMediaJump(media)
        }
    }

    onHandleOk(that, media){
        if(this.input1.state.value  ===undefined || this.state.passWordValue ===undefined ||this.input1.state.value  === ''|| this.state.passWordValue ===''){
            message.destroy()
            message.error("账号或密码不能为空！")

        }else {
            this.verifyAccount({
                account: that.input1.state.value,
                clientId: media.owner.clientId,
                password: this.state.passWordValue
            }, media)
        }
    }

    //点击跳转到网站列表
    openNetworkMediaJump(media) {
        console.log(media,'media')
        window.location.hash='#'+media.path;
       // this.props.history.push(media.path);
    }
}


ReleaseMedia.propTypes = {};

function mapStateToProps(state) {
    return {
        dataSource: state.systemReducer.navigateData,
    }
}
export default connect(mapStateToProps, null, null, {forwardRef: true})(ReleaseMedia)
